import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/tracking-health")({
  component: lazyRouteComponent(() => import("./-pages/admin.tracking-health")),
  head: () => ({
    meta: [
      { title: "Tracking Health · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
